<template>
  <!-- BEGIN: Main Menu-->
  <div class="main-menu menu-fixed menu-light menu-accordion menu-shadow" data-scroll-to-active="true">
    <div class="navbar-header">
      <ul class="nav navbar-nav flex-row">
        <li class="nav-item mr-auto">
          <router-link :to="{name: 'dashboard'}" class="navbar-brand">
            <div class="brand-logo">
              <svg class="logo" height="26px" version="1.1" viewbox="0 0 26 26" width="26px"
                   xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <title>icon</title>
                <defs>
                  <lineargradient id="linearGradient-1" x1="50%" x2="50%" y1="0%" y2="100%">
                    <stop offset="0%" stop-color="#5A8DEE"></stop>
                    <stop offset="100%" stop-color="#699AF9"></stop>
                  </lineargradient>
                  <lineargradient id="linearGradient-2" x1="0%" x2="100%" y1="0%" y2="100%">
                    <stop offset="0%" stop-color="#FDAC41"></stop>
                    <stop offset="100%" stop-color="#E38100"></stop>
                  </lineargradient>
                </defs>
                <g id="Sprite" fill="none" fill-rule="evenodd" stroke="none" stroke-width="1">
                  <g id="sprite" transform="translate(-69.000000, -61.000000)">
                    <g id="Group" transform="translate(17.000000, 15.000000)">
                      <g id="icon" transform="translate(52.000000, 46.000000)">
                        <path id="Combined-Shape"
                              d="M13.5909091,1.77272727 C20.4442608,1.77272727 26,7.19618701 26,13.8863636 C26,20.5765403 20.4442608,26 13.5909091,26 C6.73755742,26 1.18181818,20.5765403 1.18181818,13.8863636 C1.18181818,13.540626 1.19665566,13.1982714 1.22574292,12.8598734 L6.30410592,12.859962 C6.25499466,13.1951893 6.22958398,13.5378796 6.22958398,13.8863636 C6.22958398,17.8551125 9.52536149,21.0724191 13.5909091,21.0724191 C17.6564567,21.0724191 20.9522342,17.8551125 20.9522342,13.8863636 C20.9522342,9.91761479 17.6564567,6.70030817 13.5909091,6.70030817 C13.2336969,6.70030817 12.8824272,6.72514561 12.5388136,6.77314791 L12.5392575,1.81561642 C12.8859498,1.78721495 13.2366963,1.77272727 13.5909091,1.77272727 Z"></path>
                        <path id="Combined-Shape"
                              d="M13.8863636,4.72727273 C18.9447899,4.72727273 23.0454545,8.82793741 23.0454545,13.8863636 C23.0454545,18.9447899 18.9447899,23.0454545 13.8863636,23.0454545 C8.82793741,23.0454545 4.72727273,18.9447899 4.72727273,13.8863636 C4.72727273,13.5378966 4.74673291,13.1939746 4.7846258,12.8556254 L8.55057141,12.8560055 C8.48653249,13.1896162 8.45300462,13.5340745 8.45300462,13.8863636 C8.45300462,16.887125 10.8856023,19.3197227 13.8863636,19.3197227 C16.887125,19.3197227 19.3197227,16.887125 19.3197227,13.8863636 C19.3197227,10.8856023 16.887125,8.45300462 13.8863636,8.45300462 C13.529522,8.45300462 13.180715,8.48740462 12.8430777,8.55306931 L12.8426531,4.78608796 C13.1851829,4.7472336 13.5334422,4.72727273 13.8863636,4.72727273 Z"
                              fill="#4880EA"></path>
                        <path id="Combined-Shape"
                              d="M13.5909091,1.77272727 C20.4442608,1.77272727 26,7.19618701 26,13.8863636 C26,20.5765403 20.4442608,26 13.5909091,26 C6.73755742,26 1.18181818,20.5765403 1.18181818,13.8863636 C1.18181818,13.540626 1.19665566,13.1982714 1.22574292,12.8598734 L6.30410592,12.859962 C6.25499466,13.1951893 6.22958398,13.5378796 6.22958398,13.8863636 C6.22958398,17.8551125 9.52536149,21.0724191 13.5909091,21.0724191 C17.6564567,21.0724191 20.9522342,17.8551125 20.9522342,13.8863636 C20.9522342,9.91761479 17.6564567,6.70030817 13.5909091,6.70030817 C13.2336969,6.70030817 12.8824272,6.72514561 12.5388136,6.77314791 L12.5392575,1.81561642 C12.8859498,1.78721495 13.2366963,1.77272727 13.5909091,1.77272727 Z"
                              fill="url(#linearGradient-1)"></path>
                        <rect id="Rectangle" height="7.68181818" width="7.68181818" x="0" y="0"></rect>
                        <rect id="Rectangle" fill="url(#linearGradient-2)" height="7.68181818" width="7.68181818" x="0"
                              y="0"></rect>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </div>
            <h2 class="brand-text mb-0">M3</h2>
          </router-link>
        </li>
        <li class="nav-item nav-toggle"><a class="nav-link modern-nav-toggle pr-0" data-toggle="collapse"><i
            class="bx bx-x d-block d-xl-none font-medium-4 primary toggle-icon"></i><i
            class="toggle-icon bx bx-disc font-medium-4 d-none d-xl-block collapse-toggle-icon primary"
            data-ticon="bx-disc"></i></a></li>
      </ul>
    </div>
    <div class="shadow-bottom"></div>
    <div class="main-menu-content">
      <ul id="main-menu-navigation" class="navigation navigation-main" data-icon-style="" data-menu="menu-navigation">
        <template v-for="(item, index) in menu">
          <template v-if="!item.hasOwnProperty('children')">

            <li class=" navigation-header text-truncate"><span>{{ $t(item.text) }}</span></li>

            <router-link
                v-bind:key="index"
                v-slot="{ href, navigate, isActive, isExactActive }"
                :to="item.link"
            >
              <li
                  :class="[ isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                  aria-haspopup="true"
                  class="nav-item"
                  data-menu-toggle="hover"
              >
                <a :href="href" @click="navigate">
                  <i :class="`${item.icon}`"></i>
                  <span class="menu-title text-truncate"> {{ $t(item.text) }} </span>
                  <span v-if="item.badge && +item.badge !== 0"
                        class="badge-warning rounded float-right p-2"> {{ item.badge }}</span>
                </a>
              </li>
            </router-link>
          </template>
          <template v-else>
            <li class=" navigation-header text-truncate"><span>{{ $t(item.text) }}</span></li>

            <template v-for="(subMenu, subMenuIndex) in item.children">
              <li class=" nav-item">
                <router-link
                    v-bind:key="subMenuIndex"
                    v-slot="{ href, navigate, isActive, isExactActive }"
                    :to="subMenu.link">
                  <a :href="href" class="d-flex align-items-center">
                    <i class="bx" :class="subMenu.icon"></i>
                    <span class="menu-title text-truncate">{{ $t(subMenu.text) }}</span>
                  </a>
                </router-link>
              </li>
            </template>
          </template>
        </template>
      </ul>
    </div>
  </div>
  <!-- END: Main Menu-->
</template>

<script>
import {mapGetters} from "vuex";
import KTBrand from "@/view/layout/brand/Brand.vue";

import KTLayoutAside from "@/assets/js/layout/base/aside.js";
import KTLayoutAsideMenu from "@/assets/js/layout/base/aside-menu.js";
import KTMenu from "@/view/layout/aside/Menu.vue";
import moduleUser, {MODULE_NAME as MODULE_USER, SELF} from "@/core/services/store/user.module";
import store from "@/core/services/store";

const _MODULE_USER = MODULE_USER;

export default {
  name: "KTAside",
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_MODULE_USER, moduleUser);
  },
  data() {
    return {
      insideTm: 0,
      outsideTm: 0
    };
  },
  components: {
    KTBrand,
    KTMenu
  },
  mounted() {
    this.$nextTick(() => {
      // Init Aside
      KTLayoutAside.init(this.$refs["kt_aside"]);

      // Init Aside Menu
      KTLayoutAsideMenu.init(this.$refs["kt_aside_menu"]);
    });
  },
  methods: {
    hasActiveChildren(match) {
      return this.$route["path"].indexOf(match) !== -1;
    },
    hasNestedChildren(menu) {
      return menu.hasOwnProperty("children");
    },
    /**
     * Use for fixed left aside menu, to show menu on mouseenter event.
     */
    mouseEnter() {
      if (this.layoutConfig("aside.self.minimize.hoverable")) {
        // check if the left aside menu is fixed
        if (document.body.classList.contains("aside-fixed")) {
          if (this.outsideTm) {
            clearTimeout(this.outsideTm);
            this.outsideTm = null;
          }

          // if the left aside menu is minimized
          if (document.body.classList.contains("aside-minimize")) {
            document.body.classList.add("aside-minimize-hover");

            // show the left aside menu
            document.body.classList.remove("aside-minimize");
          }
        }
      }
    },

    /**
     * Use for fixed left aside menu, to show menu on mouseenter event.
     */
    mouseLeave() {
      if (this.layoutConfig("aside.self.minimize.hoverable")) {
        if (document.body.classList.contains("aside-fixed")) {
          if (this.insideTm) {
            clearTimeout(this.insideTm);
            this.insideTm = null;
          }

          if (document.querySelector(".aside-menu .scroll")) {
            document.querySelector(".aside-menu .scroll").scrollTop = 0;
          }

          // if the left aside menu is expand
          if (document.body.classList.contains("aside-minimize-hover")) {
            // hide back the left aside menu
            document.body.classList.remove("aside-minimize-hover");
            document.body.classList.add("aside-minimize");
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters(["layoutConfig", "getClasses"]),

    /**
     * Get extra classes for menu based on the options
     */
    asideMenuClass() {
      const classes = this.getClasses("aside_menu");
      if (typeof classes !== "undefined") {
        return classes.join(" ");
      }
      return null;
    },
    menu() {
      let user = this.$store.getters[_MODULE_USER + "/" + SELF];
      let items = user && user.hasOwnProperty("menu") ? user.menu : [];
      items = items.filter(item => {
        return item.is_web;
      })
      return items;
    }
  }
};
</script>
